import { WebPlugin } from '@capacitor/core';
export class CalendarWeb extends WebPlugin {
    async checkPermissions() {
        throw this.unimplemented('Not implemented on web.');
    }
    async requestPermissions(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async createEvent(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async createEventInteractively(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async modifyEvent(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async findEvents(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async deleteEvent(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async listCalendars() {
        throw this.unimplemented('Not implemented on web.');
    }
    async createCalendar(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async deleteCalendar(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async openCalendar(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map